import { Action, PayloadAction, ThunkAction } from '@reduxjs/toolkit';
import { MutationThunkArg } from '@reduxjs/toolkit/dist/query/core/buildThunks';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { store } from './store';

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export type RTKQueryAction<ResType, ReqType> = PayloadAction<
  ResType,
  string,
  {
    arg: MutationThunkArg & {
      originalArgs: ReqType;
    };
    requestId: string;
    requestStatus: 'fulfilled';
  }
>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
